import { parsePhoneNumber } from 'libphonenumber-js';

export const validateUSPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false;

  try {
    const result = parsePhoneNumber(phoneNumber, 'US');
    return result.isValid();
  } catch (e) {
    return false;
  }
};

export const isPhoneRequiredForMfa = (mfaMethod) => Boolean(mfaMethod && mfaMethod !== 'email');

export const shouldShowProfilePhoneError = (phone, mfaMethod) => {
  const trimmed = (phone || '').trim();
  if (!trimmed) {
    return isPhoneRequiredForMfa(mfaMethod);
  }
  return !validateUSPhoneNumber(trimmed);
};

export const isProfileEditFormValid = ({ name, email, phone, mfaMethod, isSetup2FA = false }) => {
  const trimmedName = (name || '').trim();
  const isEmailValid = /\S+@\S+\.\S+/.test(email || '');
  const phoneRequired = isPhoneRequiredForMfa(mfaMethod);
  const trimmedPhone = (phone || '').trim();

  let isPhoneValid = true;
  if (trimmedPhone) {
    isPhoneValid = validateUSPhoneNumber(trimmedPhone);
  } else if (phoneRequired) {
    isPhoneValid = false;
  }

  return Boolean(
    trimmedName && isEmailValid && mfaMethod && isPhoneValid && (!isSetup2FA || mfaMethod),
  );
};
